import React from 'react';
import {
  SkeletonBody,
  SkeletonCard,
  SkeletonCardMobile,
  SkeletonContainer,
  SkeletonContainerMobile,
  SkeletonHeader,
  SkeletonIcon,
  SkeletonLine,
  SkeletonTitle,
  SkeletonWrapperMobile,
  SkeletonWrapperDesktop,
} from './OverviewInsightsSkeleton.styles';

const skeletonCards: { id: string; lines: string[] }[] = [
  { id: 'momentum', lines: ['82%', '64%', '72%'] },
  { id: 'peak-airplay', lines: ['70%', '60%', '52%'] },
  { id: 'rotation', lines: ['78%', '66%', '54%'] },
  { id: 'region', lines: ['76%', '58%', '68%'] },
  { id: 'genre', lines: ['74%', '62%', '56%'] },
];

type SkeletonVariant = 'desktop' | 'mobile';

interface OverviewInsightsSkeletonProps {
  variant?: SkeletonVariant;
}

const OverviewInsightsSkeleton: React.FC<OverviewInsightsSkeletonProps> = ({
  variant = 'desktop',
}) => {
  const Wrapper =
    variant === 'mobile' ? SkeletonWrapperMobile : SkeletonWrapperDesktop;
  const Container =
    variant === 'mobile' ? SkeletonContainerMobile : SkeletonContainer;
  const Card = variant === 'mobile' ? SkeletonCardMobile : SkeletonCard;

  return (
    <Wrapper aria-hidden>
      {skeletonCards.map((card) => (
        <Container key={`overview-skeleton-${card.id}`}>
          <Card>
            <SkeletonHeader>
              <SkeletonIcon />
              <SkeletonTitle />
            </SkeletonHeader>
            <SkeletonBody>
              {card.lines.map((width) => (
                <SkeletonLine
                  key={`overview-skeleton-line-${card.id}-${width}`}
                  $width={width}
                />
              ))}
            </SkeletonBody>
          </Card>
        </Container>
      ))}
    </Wrapper>
  );
};

export default OverviewInsightsSkeleton;
